module.exports = __webpack_public_path__ + "static/instalaciones-3-612dadb361bc9dad4a46b182d362882a.jpg";